export interface DonationCertificatePathData {
  imagePath: string;
  level: number;
  minContributions: number;
  maxContributions?: number;
  title: string;
  description: string;
}

export const DONATION_CERTIFICATE_PATH_DATA: DonationCertificatePathData[] = [
  {
    imagePath: '/images/campaign/campaign_certificate_lv1.png',
    level: 1,
    minContributions: 1,
    maxContributions: 100,
    title: '크리스마스 체크셔츠',
    description: '입으면 크리스마스에 개발을 해도 슬프지 않다.',
  },
  {
    imagePath: '/images/campaign/campaign_certificate_lv2.png',
    level: 2,
    minContributions: 101,
    maxContributions: 200,
    title: '칠면조와 제로콜라 야식 세트',
    description: '밤샘 코딩 집중력을 높이고, 에너지를 충전시킨다.',
  },
  {
    imagePath: '/images/campaign/campaign_certificate_lv3.png',
    level: 3,
    minContributions: 201,
    maxContributions: 300,
    title: '루돌프 슬리퍼',
    description: '회사 내 이동 속도가 루돌프만큼 증가한다.',
  },
  {
    imagePath: '/images/campaign/campaign_certificate_lv4.png',
    level: 4,
    minContributions: 301,
    maxContributions: 400,
    title: '산타 캡모자',
    description: '팀장님의 눈을 피해 내 마음대로 개발할 수 있다.',
  },
  {
    imagePath: '/images/campaign/campaign_certificate_lv5.png',
    level: 5,
    minContributions: 401,
    maxContributions: 500,
    title: '캐롤 키보드',
    description: '타이핑하면 캐롤이 흘러나와 사기를 복돋는다.',
  },
  {
    imagePath: '/images/campaign/campaign_certificate_lv6.png',
    level: 6,
    minContributions: 501,
    maxContributions: 1000,
    title: '크롬 다이노 인형',
    description: '품에 안으면 인터넷이 끊겨 합법적으로 일을 쉰다.',
  },
  {
    imagePath: '/images/campaign/campaign_certificate_lv7.png',
    level: 7,
    minContributions: 1001,
    maxContributions: 99999,
    title: '마법의 코드북',
    description: '천재 개발자의 클린코드를 훔쳐올 수 있다.',
  },
];
